import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CancelSaveAndContinue } from '@/core/CancelSaveAndContinue.molecule';
import { doTrack } from '@/track/track.service';
import { setTrendGlobalScope } from '@/trendData/trend.actions';
import { Icon, Modal } from '@seeqdev/qomponents';

interface ScopeModalProps {
  itemId: string;
  closeModal: () => void;
  onScopeUpdate: () => void | Promise<void>;
  workbookName?: string;
}

export const ScopeModal = ({ itemId, onScopeUpdate, closeModal, workbookName }: ScopeModalProps) => {
  const { t } = useTranslation();

  const [makeGlobal, setMakeGlobal] = useState(false);

  /**
   * Makes the item available outside this analysis
   */
  const setGlobalScope = () => setTrendGlobalScope(itemId).then(onScopeUpdate).then(closeModal);

  const handleTracking = (func: () => void, info: string) => {
    doTrack('Item Properties', 'scope dialog', info);

    return func();
  };

  const scopeDescription = workbookName
    ? t('SCOPE.MODAL.DESCRIPTION_NAMED', { analysisName: workbookName })
    : t('SCOPE.MODAL.DESCRIPTION');

  return (
    <Modal
      open={true}
      onClose={closeModal}
      testId="scopeModal"
      title={t('SCOPE.MODAL.HEADER')}
      modalFooter={
        <CancelSaveAndContinue
          submitFn={() => handleTracking(setGlobalScope, 'save')}
          cancelFn={() => handleTracking(closeModal, 'cancel')}
          btnDisabled={!makeGlobal}
          values={[]}
        />
      }>
      <div className="text-center">
        <div>{scopeDescription}</div>
        <div className="sq-text-warning text-bolder">{t('SCOPE.MODAL.WARNING')}</div>
        <div
          className="mt10 mb10 font-size-larger text-interactive"
          onClick={() => setMakeGlobal((makeGlobal) => !makeGlobal)}
          data-testid="toggleScope">
          <Icon
            icon={makeGlobal ? 'fa-toggle-on' : 'fa-toggle-off'}
            iconPrefix="fa-solid"
            large={true}
            extraClassNames="pr5"
          />
          <span>{t('SCOPE.MODAL.MAKE_GLOBAL')}</span>
        </div>
      </div>
    </Modal>
  );
};
